module.exports = __webpack_public_path__ + "img/burger.187fb3b1.svg";